import React, { useRef, useState } from "react";
import {
	Text,
	TextInput,
	View,
	StyleSheet,
	useWindowDimensions,
	Image,
	Pressable,
	TouchableOpacity,
	ActivityIndicator
} from "react-native";
import SimpleAlert from "../components/customerAlerts/SimpleAlert";
import {
	colors,
	globalStyles,
	ScreenContainer,
} from "../components/Shared";
import AuthService, { authErrors } from "../services/auth";
import { RootStackScreenProps } from "../types";

const authService = new AuthService();

export default function SinginScreen({ navigation }: RootStackScreenProps<"Singin">) {
	const emailRef = useRef<TextInput>();
	const passwordRef = useRef<TextInput>();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [modal, setModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const [modalData, setModalData] = useState({ title:'', description:'', action:'' })

	const window = useWindowDimensions();

	const toLogin = async () => {
		setLoading(true);
		const login = await authService.singIn(email, password);
		setLoading(false);

		switch (login) {
			case authErrors.emptyFields:
				setModalData({ title: 'Please', description:'Fill all the fields', action: login });
				setModal(true);
				break;
			case authErrors.invalidEmail:
				setModalData({ title: 'Please', description:'Fill with a valid email', action: login });
				setModal(true);
				break;
			case authErrors.loginWrongCredential:
				setModalData({ title: "We're sorry", description:'The credentials are wrong', action: login });
				setModal(true);
				break;
			case 'OK':
				break;
			default:
				setModalData({ title: 'Error', description:'Please try it again in a few minutes', action: login })
				setModal(true);
				break;
		}
	};

	return (
		<ScreenContainer style={[globalStyles.centerFlex, { backgroundColor: colors.bg.white}]}>
			<View
				style={[
				styles.container,
				{ width: window.width > 1000 ? 1000 : "100%" },
				]}
			>
				<Image
					source={require("../assets/images/logo.png")}
					style={styles.logo}
				/>

				<TextInput
					style={[
						globalStyles.transparentBorderInput,
						{ width: window.width < 390 ? "96%" : 300, paddingLeft: 5 },
					]}
					placeholder="Email address"
					placeholderTextColor="#d8d8d8"
					onChangeText={setEmail}
					ref={() => emailRef}
					onSubmitEditing={() => passwordRef.current?.focus()}
					blurOnSubmit={false}
					value={email}
					keyboardType="default"
				/>

				<TextInput
					style={[
						globalStyles.transparentBorderInput,
						{ width: window.width < 390 ? "96%" : 300, paddingLeft: 5 },
					]}
					placeholder="Password"
					placeholderTextColor="#d8d8d8"
					onChangeText={setPassword}
					ref={() => passwordRef}
					onSubmitEditing={() => toLogin()}
					blurOnSubmit={false}
					value={password}
					keyboardType="default"
					secureTextEntry={true}
				/>

				<TouchableOpacity
					onPress={() => toLogin()}
					style={[
						styles.singInButton,
						{
						opacity: loading ? 0.5 : 1,
						width: window.width < 390 ? "90%" : 280,
						},
					]}
				>
					{loading ? (
						<ActivityIndicator color="#ffffff" />
					) : (
						<Text style={styles.singInButtonText}>Sing In</Text>
					)}
				</TouchableOpacity>

				<View style={styles.singUpTextContain}>
					<Text style={styles.singUpText}>
						Don't have an account?
						<Pressable onPress={() => navigation.navigate("SingUp")}>
						<Text> Sing Up </Text>
						</Pressable>
					</Text>
				</View>

				<SimpleAlert 
					title={modalData.title}
					description={modalData.description}
					visible={modal}
					close={() => {
						setModal(false);
						if(modalData.action === authErrors.emptyFields){
							if (!email) {
								return setTimeout(() => emailRef.current?.focus(), 500);
							}

							if (!password) {
								return setTimeout(() => passwordRef.current?.focus(), 500);
							}
						}

						if (modalData.action === authErrors.invalidEmail) {
							return setTimeout(() => emailRef.current?.focus(), 500);
						}

						if (modalData.action === authErrors.invalidPassword) {
							setTimeout(() => passwordRef.current?.focus(), 500);
						}
					}}
				/>
			</View>
		</ScreenContainer>
	);
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		flexWrap: "wrap",
		justifyContent: "center",
		alignItems: "center",
		// backgroundColor: "green",
	},
	logo: {
		width: 96,
		height: 100,
		marginLeft: "auto",
		marginRight: "auto",
		padding: 10,
	},
	title: {
		fontSize: 35,
	},
	input: {},
	forgotPasswordContainer: {},
	forgotPassword: {},
	singInButton: {
		backgroundColor: "#FF7D70",
		borderRadius: 5,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		marginTop: 40,
		height: 50,
		shadowColor: "#000",
		shadowOffset: { width: 0, height: 5 },
		shadowOpacity: 0.3,
		shadowRadius: 5,
	},
	singInButtonText: {
		color: "#fff",
		fontSize: 18,
	},
	singUpTextContain: {
		marginTop: 20
	},
	singUpText: {
		fontSize: 13
	}
});
